import { IInvoice, TCFDIVersion } from 'models/invoices.models'
import { selectCreatePaymentComplement } from 'lib/helpers/selectors'
import useDialog from 'hooks/Shared/useDialog'
import { useAppSelector } from 'store/hooks'
import { useMutation } from '@tanstack/react-query'
import { createPaymentComplement } from 'services/Invoices/invoices.services'
import { selectErrorDialog } from 'lib/helpers/errors.helpers'
import { IApiError } from 'services/Shared/shared.models'

interface IUseAddPaymentComplementProps {
  activeWorkspace: number
  invoice: IInvoice | null
  version: TCFDIVersion
  onSuccess: () => void
}

const useAddPaymentComplement = ({
  activeWorkspace,
  invoice,
  version,
  onSuccess,
}: IUseAddPaymentComplementProps) => {
  const dialog = useDialog()

  const form = useAppSelector(selectCreatePaymentComplement)

  const mutation = useMutation<void, IApiError, void>(
    () => {
      if (!invoice) throw new Error('CFDI cargado incorrectamente')
      return createPaymentComplement(activeWorkspace, invoice, form, version)
    },
    {
      onSuccess: () => {
        onSuccess()
      },
      onError: async (error, variables, ctx) => {
        if (error.message === 'mutation-cancelled') return
        const op = selectErrorDialog(error)
        if (op?.variant) {
          await dialog[op.variant](op)
          return
        }
        dialog.danger({
          subtitle:
            'No se pudo actualizar la información de la categoría seleccionada.',
          primaryButtonText: 'Reintentar',
          secondaryButtonText: 'Cancelar',
          onPrimaryClick: () => mutation.mutate(variables),
        })
      },
    }
  )

  return mutation
}

export default useAddPaymentComplement
